<template>
    <div>
        <div class="top-bar clearfix">
            <div class="text-control">
                <div :class="'text-input clearfix ' + searchClass" :selected="adminSelected">
                    <span class="vert-spacer"></span>
                    <span class="vertically-spaced"><input class="search-input" type="text" :placeholder="searchPlaceholder" v-model="adminText" @focus="focusAdminInput" @blur="blurAdminInput" v-on:keyup.enter="search" /></span>
                    <a class="vertically-spaced" href="#" title="Search" @click.prevent="search">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'search']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                    <a class="vertically-spaced" href="#" title="Show/Hide search helper" @click.prevent="toggleHelper">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'hashtag']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                </div>
            </div>

            <div class="text-control">
                <form method="post" action="/account/log-on-as" @submit="submitLoginForm">
                    <input type="hidden" :name="afField" v-model="afValue" />
                    <div :class="'text-input clearfix ' + loginAsClass" :selected="loginAsSelected">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced"><input name="Username" class="login-as-input" type="text" :placeholder="loginAsPlaceholder" v-model="loginAsText" @focus="focusLoginAsInput" @blur="blurLoginAsInput" /></span>

                        <button class="vertically-spaced" type="submit">
                            <span class="vert-spacer"></span>
                            <span class="vertically-spaced">
                                <fa-icon class="nav-icon" :icon="['fas', 'sign-in-alt']" aria-hidden="true"></fa-icon>
                            </span>
                        </button>
                    </div>
                </form>
            </div>

            <a href="#" @click.prevent="close" title="Close" arial-label="Close">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'circle-xmark']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="/task-manager" title="Task Manager" arial-label="Task Manager">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'tasks']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="/report/admin-reports" title="Reports" arial-label="Reports">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'table']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="/analytics/admin" title="Analytics" arial-label="Analytics">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'chart-line']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="/mongo/admin" title="Mongo Administration" arial-label="Mongo Administration">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'database']" aria-hidden="true"></fa-icon></span>
            </a>
            <a v-show="!showResults" href="#" title="Show Search Results" @click.prevent="toggleView" arial-label="Show Search Results">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'address-book']" aria-hidden="true"></fa-icon></span>
            </a>
            <a v-show="showResults" href="#" title="Show History" @click.prevent="toggleView" arial-label="Show History">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'bookmark']" aria-hidden="true"></fa-icon></span>
            </a>
        </div>

        <div v-show="showHelper" class="top-bar clearfix search-helper">
            <div class="text-control">
                <div class="text-input clearfix">
                    <span class="vert-spacer"></span>
                    <span class="vertically-spaced">
                        <select name="search-option" v-model="selectedParam">
                            <option value="keywords">Search Keywords</option>
                            <option value="accountid">Account #</option>
                            <option value="region">State/Province</option>
                            <option value="product">Product</option>
                            <option value="service">Service</option>
                            <option value="network">Dealer Network</option>
                            <option value="status">Account Status</option>
                            <option value="type">Account Type</option>
                            <option value="csr">CSR</option>
                            <option value="site">Site</option>
                            <option value="misc">Miscellaneous</option>
                        </select>
                    </span>
                </div>
            </div>

            <div class="text-control">
                <div class="text-input clearfix">
                    <span class="vert-spacer"></span>
                    <span class="vertically-spaced">
                        <select v-if="isParamList" v-model="paramValue" class="search-value-select" name="search-values">
                            <option v-for="itm in paramItems" :key="itm.value" v-bind:value="itm.value">{{ itm.display }}</option>
                        </select>
                        <input v-if="!isParamList" v-model="paramValue" class="search-value-input" name="search-value" type="text" />
                    </span>
                    <a class="vertically-spaced primary" href="#" title="Add" @click.prevent="addHelper">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'circle-right']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                    <a class="vertically-spaced" href="#" title="Clear" @click.prevent="clearHelper">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'circle-minus']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                    <a :class="'vertically-spaced ' + orClass" href="#" title="Set as OR statement" @click.prevent="setOr">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'circle-pause']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                    <a :class="'vertically-spaced ' + negativeClass" href="#" title="Set as Negative statement" @click.prevent="setNegative">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">
                            <fa-icon class="nav-icon" :icon="['fas', 'circle-exclamation']" aria-hidden="true"></fa-icon>
                        </span>
                    </a>
                </div>
            </div>
        </div>

        <div v-show="!showResults" class="top-bar account-history-control clearfix">
            <a href="#" title="Show Recently Viewed Accounts" @click.prevent="showRecent" arial-label="Show Recently Viewed Accounts">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'clipboard-user']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="#" title="Show Bookmarked Accounts" @click.prevent="showBookmarked" arial-label="Show Bookmarked Accounts">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'bookmark']" aria-hidden="true"></fa-icon></span>
            </a>
        </div>

        <div v-show="showResults" class="top-bar admin-search-control clearfix">
            <a href="#" class="showUsers" title="Show Users" @click.prevent="showUsers" arial-label="Show Users">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'users']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="#" class="showLocations" title="Show Locations" @click.prevent="showLocations" arial-label="Show Locations">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'location-dot']" aria-hidden="true"></fa-icon></span>
            </a>
            <a href="#" class="showAccounts" title="Show Accounts" @click.prevent="showAccounts" arial-label="Show Accounts">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'building']" aria-hidden="true"></fa-icon></span>
            </a>
        </div>

        <div v-show="!showResults" class="account-history">
            <div :class="'card recent ' + historyView">
                <h3>Recently Viewed Accounts</h3>
                <div v-if="isHistoryLoaded">
                    <div v-if="recent.length === 0">
                        No recently viewed accounts.
                    </div>
                    <div v-for="itm in recent" :key="itm.id" class="item clearfix">
                        <a class="link" :href="getViewAccountUrl(itm.accountId)" :alt="itm.name" title="View Account">{{ itm.name }}</a>
                        <a class="action" href="#" @click.prevent="addBookmark(itm.accountId)" title="Bookmark Account"><fa-icon :icon="['far', 'bookmark']" aria-hidden="true"></fa-icon></a>
                    </div>
                </div>
                <div v-else><fa-icon class="nav-icon" :icon="['fas', 'spinner']" aria-hidden="true" spin></fa-icon></div>
            </div>
            <div :class="'card bookmarked ' + historyView">
                <h3>Bookmarked Accounts</h3>
                <div v-if="isHistoryLoaded">
                    <div v-if="bookmarked.length === 0">
                        No bookmarked accounts.
                    </div>
                    <div v-for="itm in bookmarked" :key="itm.id" class="item clearfix">
                        <a class="link" v-bind:href="getViewAccountUrl(itm.accountId)" v-bind:alt="itm.name" title="View Account">{{ itm.name }}</a>
                        <a class="action" href="#" @click.prevent="removeBookmark(itm.accountId)" title="Remove Bookmark"><fa-icon :icon="['fas', 'trash-can']" aria-hidden="true"></fa-icon></a>
                    </div>
                </div>
                <div v-else><fa-icon class="nav-icon" :icon="['fas', 'spinner']" aria-hidden="true" spin></fa-icon></div>
            </div>
        </div>

        <div v-show="showResults" class="admin-search-results">
            <div :class="'card accounts ' + searchView">
                <h3>Accounts</h3>
                <div class="result-counts" v-show="accounts.results.length > 0">
                    Displaying {{ getStartCount(accounts) }} - {{ getEndCount(accounts) }} of {{ accounts.total }}
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(accounts)" class="prev" href="#" @click.prevent="accounts.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(accounts)" class="next" href="#" @click.prevent="accounts.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>

                <div v-if="accounts.active" class="loading">
                    <fa-icon class="nav-icon" :icon="['fas', 'spinner']" aria-hidden="true" spin></fa-icon>
                </div>
                <div v-if="!accounts.active && accounts.results.length === 0">
                    No accounts returned in search.
                </div>
                <div v-if="!accounts.active" v-for="itm in accounts.results" :key="itm._id" class="item clearfix">
                    <a class="link" :href="itm.view" :alt="itm.desc" title="View">{{ itm.desc }}</a>
                    <a class="action" href="itm.edit" title="Edit Account"><fa-icon :icon="['fas', 'edit']" aria-hidden="true"></fa-icon></a>
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(accounts)" class="prev" href="#" @click.prevent="accounts.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(accounts)" class="next" href="#" @click.prevent="accounts.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>
            </div>
            <div :class="'card locations ' + searchView">
                <h3>Locations</h3>
                <div class="result-counts" v-show="locations.results.length > 0">
                    Displaying {{ getStartCount(locations) }} - {{ getEndCount(locations) }} of {{ locations.total }}
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(locations)" class="prev" href="#" @click.prevent="locations.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(locations)" class="next" href="#" @click.prevent="locations.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>

                <div v-if="locations.active" class="loading">
                    <fa-icon class="nav-icon" :icon="['fas', 'spinner']" aria-hidden="true" spin></fa-icon>
                </div>
                <div v-if="!locations.active && locations.results.length === 0">
                    No locations returned in search.
                </div>
                <div v-if="!locations.active" v-for="itm in locations.results" :key="itm._id" class="item clearfix">
                    <a class="link" :href="itm.view" :alt="itm.desc" title="View">
                        {{ itm.desc }}
                        <span class="link-secondary" v-if="itm.accountData">{{ itm.accountData.desc }}</span>
                    </a>
                    <a v-if="itm.accountData" class="action" href="itm.accountData.view" title="View Account"><fa-icon :icon="['fas', 'building']" aria-hidden="true"></fa-icon></a>
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(locations)" class="prev" href="#" @click.prevent="locations.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(locations)" class="next" href="#" @click.prevent="locations.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>
            </div>
            <div :class="'card users ' + searchView">
                <h3>Users</h3>
                <div class="result-counts" v-show="users.results.length > 0">
                    Displaying {{ getStartCount(users) }} - {{ getEndCount(users) }} of {{ users.total }}
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(users)" class="prev" href="#" @click.prevent="users.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(users)" class="next" href="#" @click.prevent="users.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>
                <div v-if="users.active" class="loading">
                    <fa-icon class="nav-icon" :icon="['fas', 'spinner']" aria-hidden="true" spin></fa-icon>
                </div>
                <div v-if="!users.active && users.results.length === 0">
                    No users returned in search.
                </div>
                <div v-if="!users.active" v-for="itm in users.results" :key="itm._id" class="item clearfix">
                    <a class="link" :href="itm.view" :alt="itm.desc" title="View">
                        {{ itm.desc }}
                        <span class="link-secondary" v-if="itm.accountData">{{ itm.accountData.desc }}</span>
                    </a>
                    <a v-if="itm.accountData" class="action" href="itm.accountData.view" title="View Account"><fa-icon :icon="['fas', 'building']" aria-hidden="true"></fa-icon></a>
                </div>
                <div class="clearfix pager">
                    <a v-show="showPrevious(users)" class="prev" href="#" @click.prevent="users.previous"><fa-icon :icon="['fas', 'backward']" aria-hidden="true"></fa-icon></a>
                    <a v-show="showNext(users)" class="next" href="#" @click.prevent="users.next"><fa-icon :icon="['fas', 'forward']" aria-hidden="true"></fa-icon></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>import script from './controlPanel';
    export default script;</script>

<style lang="less" scoped>
    @import "./controlPanel.less";
</style>